import { memo } from 'react';
import { Box } from '@bridebook/ui';
import componentStyles from './video-widget.style';
import { IVideoWidget } from '@bridebook/toolbox/src/seo-facets/search-widgets';

interface IProps {
  widget: IVideoWidget | null;
}

const VideoWidget = ({ widget }: IProps) => {
  const styles = componentStyles();

  if (!widget) {
    return null;
  }

  return (
    <Box style={styles.container}>
      {widget.title && (
        <Box as="h5" style={styles.title}>
          {widget.title}
        </Box>
      )}
      <Box
        as="iframe"
        style={styles.iframe}
        src={`https://www.youtube.com/embed/${widget.content}?controls=0`}
        allowFullScreen></Box>
    </Box>
  );
};

export default memo(VideoWidget);
